import layout from '@/layout/index.vue'
export default {
  name: 'group-spm-transfer',
  meta: { title: '传送', icon: 'icon-transfer' },

  children: [
    {
      name: 'spm-transfer',
      meta: { title: '传送', icon: 'icon-transfer' },

      routers: [
        {
          path: '/transfer',
          name: 'transfer',
          component: layout,
          children: [
            {
              path: 'index',
              name: 'index',
              component: () => import('@/views/transfer/index.vue'),
              meta: {
                title: '传送',
                vPermission: ['pc-bar-transfer:order-make-transfer:wait-list']
              }
            }
          ]
        }
      ]
    }
  ]
}
